<template lang="html">
  <div class="">
    <v-text-field
      label="Max guests"
      :value="maxGuests"
      @input="inputMaxGuests"
      :rules="[validNumber]"
      autocomplete="off"
      :disabled="disabled"
    />
    <v-text-field
      label="Max bookings"
      :value="maxBookings"
      @input="inputMaxBookings"
      :rules="[validNumber]"
      autocomplete="off"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import {getItemById, getItemIdxById} from '@dynapp/wc-api-generic';

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  data() {
    return {
      maxGuests: '',
      maxBookings: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        var item = getItemById(value || [], 'Max guests', 'title');
        if (item) {
          this.maxGuests = item.value;
        }
        item = getItemById(value || [], 'Max bookings', 'title');
        if (item) {
          this.maxBookings = item.value;
        }
      }
    }
  },
  methods: {
    validNumber: (v) => !v || Number(v) == v || 'Invalid number',
    setValue(title, value) {
      var array = this.value.slice(0);
      var index = getItemIdxById(array, title, 'title');
      if (index != null) {
        array[index] = value;
      } else {
        array.push(value);
      }
      return array;
    },
    deleteValue(title) {
      var array = this.value.slice(0);
      var index = getItemIdxById(array, title, 'title');
      if (index != null) {
        array.splice(index, 1);
      }
      return array;
    },
    inputMaxGuests(value) {
      var _value = {
        title: 'Max guests',
        type: 'events_max_value',
        property: 'guests',
        value: Number(value)
      };
      var result;
      if (value) {
        result = this.setValue(_value.title, _value);
      } else {
        result = this.deleteValue(_value.title);
      }
      this.onInput(result);
    },
    inputMaxBookings(value) {
      var _value = {
        title: 'Max bookings',
        type: 'events_max_count',
        value: Number(value)
      };
      var result;
      if (value) {
        result = this.setValue(_value.title, _value);
      } else {
        result = this.deleteValue(_value.title);
      }
      this.onInput(result);
    },
    onInput(value) {
      var emitValue = value.slice(0);
      emitValue.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
      this.$emit('input', emitValue);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
